import { sendRequestJson } from "@/utils";

export class ConfigRepository {
	constructor() {
		let host = window.location.hostname;
		if (host === "localhost" || host.startsWith("192.168")) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL;
		} else {
			this.urlBase = window.location.origin;
		}
	}

	async loadSystemConfig() {
		const url = this.urlBase + "/world/api/systemconfig";
		try {
			const configResult = await sendRequestJson({ data: null, url, method: "GET" }, false);
			if (configResult.result === 0) {
				return configResult;
			} else {
				console.log("Error cargando configuración del sistema");
			}
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo la configuración.");
		}
	}

	async getLogicalDate() {
		const url = this.urlBase + "/world/api/config/logical-date";
		try {
			const result = await sendRequestJson({ data: null, url, method: "POST" });
			if (result && result.result === 0 && result.logicalDate) {
				return result.logicalDate;
			} else {
				console.error("Error obteniendo la fecha lógica del sistema", result);
				return null; // Explicitly return null instead of undefined
			}
		} catch (e) {
			console.error("Ups, algo ha ido mal obteniendo la fecha lógica.", e);
			return null; // Explicitly return null instead of undefined
		}
	}
}

export const configRepository = new ConfigRepository();
